/* eslint-disable react/prop-types */
import React from 'react';
import { Flex, Box } from 'rebass';
import {
  height,
  minHeight,
  minWidth,
  width,
  maxWidth,
  overflow,
  boxShadow,
  padding,
  backgroundColor,
} from 'styled-system';
import styled from 'styled-components';

/**
 * @typedef {Object} CardPartialProps
 * @property {number} height
 * @property {number} minHeight
 * @property {number} minWidth
 * @property {import('styled-system').OverflowProps} overflow
 * @property {import('styled-system').BoxShadowProps} boxShadow
 */

/**
 * @typedef {CardPartialProps & import('rebass').FlexProps} CardProps
 */

/**
 * @param {CardProps} props
 */
export function Card({ children, ...props }) {
  return <CardView {...props}>{children}</CardView>;
}

Card.defaultProps = {
  flexDirection: 'column',
  bg: 'rgba(255, 255, 255, 0.8)',
};

export const CardHeader = styled(Box)`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 20px 16px 20px;
  ${padding}
`;

export const CardBody = styled(Box)`
  width: 100%;
  padding: 0px 20px 20px 20px;
  ${padding}
`;

export const CardTitle = styled(Box)`
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.greys.main};
`;

export const CardView = styled(Flex)`
  position: relative;
  overflow: hidden;
  border-radius: 16px;
  border: 1px solid #e9eaeb;
  text-decoration: none;
  word-break: break-word;
  ${height};
  ${minHeight};
  ${minWidth};
  ${width};
  ${maxWidth};
  ${overflow};
  ${boxShadow};
  ${backgroundColor}
`;
